import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, IconButton, Paper } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Image, Input, Layout, Loading, UserNavbar } from '../../../components';
import CategoryTable from './components/Table';
import * as CategoryActions from '../../../core/categories/actions';
import Search from '../../../assets/svg/search.svg';
import ModalAddCategory from './components/ModalAddCategory';

const inputStyles = {
  backgroundColor: '#fffdfd98',
  borderRadius: 50,
  width: '100vw',
  height: 95,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: '#EE7B57',
};

function Categories() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const [selectedCategory, setCategory] = useState(null);

  const { inputSearch, categoryList, categoryFilteredList, loading } = useSelector(
    (store) => store.categories,
  );

  const handleClose = () => setOpen(false);

  const onSave = (action, category) => {
    if (action === 'update') dispatch(CategoryActions.onUpdateCategory(category));
    else if (action === 'create') dispatch(CategoryActions.onCreateCategory(category));
  };

  const onSearch = (e) => {
    dispatch(CategoryActions.onSearchCategory(e.target.value));
  };

  const openModalUpdate = (category) => {
    setCategory(category);
    setModalData({
      title: 'Update category',
      action: 'update',
    });
    setOpen(true);
  };

  const openModalCreate = () => {
    setModalData({
      title: 'Add new category',
      action: 'create',
    });
    setOpen(true);
  };

  const onDisableCategory = (category) => {
    dispatch(CategoryActions.onDisableCategory(category.id, !category.state));
  };

  const onDeleteCategory = (category) => {
    dispatch(CategoryActions.onDeleteCategory(category));
  };

  const getCategoryList = () =>
    categoryFilteredList.length > 0 || inputSearch.trim() !== ''
      ? categoryFilteredList
      : categoryList;

  useEffect(() => {
    dispatch(CategoryActions.getCategories());
  }, [dispatch]);

  return (
    <Layout>
      <UserNavbar />
      {loading && <Loading />}

      {modalData && (
        <ModalAddCategory
          open={open}
          action={modalData.action}
          category={selectedCategory}
          title={modalData.title}
          handleClose={handleClose}
          onSave={onSave}
        />
      )}

      <Grid container justifyContent="center" marginTop={30}>
        <Grid item xs={9} style={inputStyles} marginBottom={3}>
          <h1>Categories</h1>
        </Grid>
        <Grid item xs={9} style={inputStyles}>
          <Input
            type="text"
            value={inputSearch}
            style={{ width: '65vw', marginTop: 4 }}
            placeholder="Typing some here..."
            onChange={onSearch}
          />
        </Grid>
      </Grid>
      <Grid container justifyContent="center" marginTop={5}>
        <Grid container justifyContent="flex-end">
          <Grid xs={2} marginBottom={2} marginRight={8}>
            <Button
              style={{ borderRadius: 20 }}
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => openModalCreate()}>
              Add category
            </Button>
          </Grid>
        </Grid>
        <Grid xs={10}>
          <CategoryTable
            onDisableCategory={onDisableCategory}
            openModalUpdate={openModalUpdate}
            categoryList={getCategoryList()}
            onDelete={onDeleteCategory}
          />
        </Grid>
      </Grid>
    </Layout>
  );
}

Categories.propTypes = {};

export default Categories;
